import { PhoneOperation } from "namirasoft-core";
import { IValidationNumberProps } from "./props/IValidationNumberProps";
import { IValidationProps } from "./props/IValidationProps";
import { IValidationStringProps } from "./props/IValidationStringProps";
import { DateSchema, DurationSchema, EmailSchema, IPV4Schema, IPV6Schema, TimeSchema } from "namirasoft-schema";

export class Validator
{
    static getError(name: string, value: string | number | boolean | null | undefined, validator: IValidationProps): string | null
    {
        if (validator.required)
            if (value == null || value === "")
                return `${name} is required.`;
        if (value != null)
            if (validator.regex)
            {
                if (!new RegExp(validator.regex.regex).test(value + ""))
                    return `${name} does not match regex ${validator.regex.regex}.`;
            }
        if (value != null)
            if (validator.validator)
            {
                let error = validator.validator(name, value);
                if (error)
                    return error;
            }

        if (value != null)
        {
            if (validator.valids)
                if (validator.valids.length > 0)
                    if (!validator.valids.includes(value + ""))
                        return `${value} is not a valid value for ${name}. Valid values are ${validator.valids.join(", ")}.`;
            if (validator.invalids)
                if (validator.invalids.length > 0)
                    if (validator.invalids.includes(value + ""))
                        return `${value} is an invalid value for ${name}. Invalid values are ${validator.invalids.join(", ")}.`;
        }
        return null;
    }
    static getErrorString(name: string, value: string | null | undefined, validator: IValidationStringProps): string | null
    {
        if (value != null)
        {
            if (validator.min_length != null)
                if (value.length < validator.min_length)
                    return `Min length of ${name} should be ${validator.min_length} characters.`;
            if (validator.max_length != null)
                if (validator.max_length < value.length)
                    return `Max length of ${name} should be ${validator.max_length} characters.`;
        }
        return null;
    }
    static getErrorNumber(name: string, value: number | null | undefined, validator: IValidationNumberProps): string | null
    {
        if (value != null)
        {
            if (isNaN(value))
                return `${name} is not a number.`;
            // eslint-disable-next-line
            if (validator.min != null)
                if (value < validator.min)
                    return `Min value of ${name} should be ${validator.min} characters.`;
            // eslint-disable-next-line
            if (validator.max != null)
                if (validator.max < value)
                    return `Max value of ${name} should be ${validator.max} characters.`;
        }
        return null;
    }
    static getErrorArray<T>(name: string, value: T[], required: boolean, min?: number, max?: number): string | null 
    {
        if (required)
            // eslint-disable-next-line
            if (value == null || value.length == 0)
                return `${name} is required.`;
        if (value != null)
        {
            if (min != null)
                if (value.length < min)
                    return `Min length of ${name} should be ${min} characters.`;
            if (max != null)
                if (max < value.length)
                    return `Max length of ${name} should be ${max} characters.`;
        }
        return null;
    }
    static getErrorEmail(name: string, value: string | null | undefined, validator: IValidationProps): string | null
    {
        if (!validator.required)
            if (!value)
                return null;
        return Validator.getError(name, value, {
            required: true, regex: {
                name: "Email",
                regex: EmailSchema.REGEX
            }
        });
    }
    static getErrorDate(name: string, value: string | null | undefined): string | null
    {
        return Validator.getError(name, value, {
            required: true, regex: {
                name: "Date",
                regex: DateSchema.REGEX
            }
        });
    }
    static getErrorTime(name: string, value: string | null | undefined): string | null
    {
        return Validator.getError(name, value, {
            required: true, regex: {
                name: "Time",
                regex: TimeSchema.REGEX
            }
        });
    }
    static getErrorDateTime(name: string, value: Date | null | undefined): string | null
    {
        if (value != null)
        {
            const dateTime = new Date(value);
            if (isNaN(dateTime.getTime()))
                return `${value} is not a valid DateTime for ${name}.`;
        }
        return null;
    }
    static getErrorDuration(name: string, value: string | null | undefined): string | null
    {
        return Validator.getError(name, value, {
            required: true, regex: {
                name: "Duration",
                regex: DurationSchema.REGEX
            }
        });
    }
    static getErrorIPV4(name: string, value: string | null | undefined): string | null
    {
        return Validator.getError(name, value, {
            required: true, regex: {
                name: "IP",
                regex: IPV4Schema.REGEX
            }
        });
    }
    static getErrorIPV6(name: string, value: string | null | undefined): string | null
    {
        return Validator.getError(name, value, {
            required: true, regex: {
                name: "IP",
                regex: IPV6Schema.REGEX
            }
        });
    }
    static getErrorPhone(name: string, value: string | null | undefined): string | null
    {
        return Validator.getError(name, value, {
            required: true, validator: () =>
            {
                if (value)
                    if (!PhoneOperation.isValid(value))
                        return `${name} is not a valid phone number`;
                return null;
            }
        });
    }
}